export const SET_FINANCIAL_CALCULATOR_DATA  = "SET_FINANCIAL_CALCULATOR_DATA"
